import { defineComponentStyle } from "@/components/ui"

export const inputElementStyle = defineComponentStyle({
  base: {
    alignItems: "center",
    color: "fg.subtle",
    display: "flex",
    fontSize: "1em",
    height: "full",
    justifyContent: "center",
    position: "absolute",
    zIndex: "kurillin",
  },

  props: {
    /**
     * If `true`, the element clickable.
     *
     * @default false
     */
    clickable: {
      false: {
        pointerEvents: "none",
      },
      true: {
        pointerEvents: "auto",
      },
    },
    /**
     * The placement of the element.
     *
     * @default 'start'
     */
    placement: {
      end: {
        insetInlineEnd: "0",
      },
      start: {
        insetInlineStart: "0",
      },
    },
  },
})

export type InputElementStyle = typeof inputElementStyle
